import {useState, useEffect} from 'react';
import {useDispatch, useSelector, useStore} from 'react-redux';

import CopyShareLink from './CopyShareLink';
import {updateSidebarMode} from '../../actions/updateSidebarMode';

import saveProspectus from '../../actions/saveProspectus';

import {motion} from 'framer-motion';

import {authAnimation} from '../../animations';

const Share = () => {

    const store = useStore().getState();

    const {shareLink, user, saved} = useSelector((state) => state.user)
    const {inActiveCourses, activeCourses} = useSelector((state) => state.prospectus)

    const [saveText, setSaveText] = useState('Save');

    const dispatch = useDispatch();

    const handleSwitchToLogin = () => {
        dispatch( updateSidebarMode( 'login' ) );
    }

    const handleSwitchToRegister = () => {

        dispatch( updateSidebarMode( 'register' ) );
    }

    /**
     * User clicked the save button, fire the action &&
     * set a loading text on the button.
     */
    const handleSave = (evt) => {
        evt.preventDefault();

        setSaveText( 'loading...' );

        // Save the prospectus.
        dispatch(saveProspectus(store.prospectus, user.jwtAuthToken));
    }

    /**
     * When the saved state changes toggle the loading visuals.
     */
    useEffect(() => {

        if ( saved ) {
            setSaveText( 'save' );

            setTimeout(() => {
                dispatch({ type: 'HIDE_SAVED' })
            }, 3000);
        }

    }, [saved]);

    return (
        <motion.div
        layoutId="auth"
        key="share"
        className=""
        variants={authAnimation}
        initial="initial"
        animate="visible"
        exit="exit">

            <h3>Share</h3>
            <CopyShareLink shareLink={shareLink} />

            {
                ! user.jwtAuthToken ? (
                    <div className="text-center">
                        <p className="is-7 meta">To share this prospectus, you'll need to sign up/login. Follow the link below to do that</p>
                        <button className="cursor button login" onClick={handleSwitchToLogin}>Login</button>
                        <button className="is-family-secondary btn is-family-secondary cursor underlined is-7 text-center"onClick={handleSwitchToRegister}>Sign up</button>
                    </div>
                ) : ''
            }

            {
                user.jwtAuthToken ? (
                    <div>
                        <p className="is-7 meta">Before you can share your prospectus you need to:
                            <ol className="todo">
                                <li>Add courses to your prospectus</li>
                                <li>Save your prospectus</li>
                            </ol>
                        </p>
                        {
                            ( inActiveCourses.length > 0 || activeCourses.length > 0 ) &&
                            <div>
                                <div className="errors">
                                    {saved ? (
                                        <div className="alert success">Prospectus saved</div>
                                    ) : ''}
                                </div>

                                <button className="button outline" onClick={handleSave}>{saveText}</button>
                            </div>
                        }
                    </div>
                ) : ''
            }
        </motion.div>
    );
}

export default Share;